var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatConversationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication / Chat_Conversation_Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.63407 14.6585C11.4399 14.5027 13.667 12.1782 13.667 9.33349C13.667 6.38789 11.2791 4 8.33349 4C5.38789 4 3 6.38789 3 9.33349C3 10.383 3.30306 11.3617 3.82659 12.1869L3.44967 13.3177L3.44907 13.3193C3.3047 13.7524 3.23248 13.9691 3.28391 14.1133C3.32871 14.2389 3.42818 14.338 3.55384 14.3828C3.69755 14.434 3.91269 14.3623 4.34288 14.2189L4.349 14.2171L5.48011 13.8401C6.30526 14.3637 7.284 14.6668 8.33355 14.6668C8.4344 14.6668 8.5346 14.664 8.63407 14.6585ZM8.63407 14.6585C8.63415 14.6587 8.634 14.6583 8.63407 14.6585ZM8.63407 14.6585C9.36381 16.7345 11.3417 18.2228 13.6671 18.2228C14.7167 18.2228 15.6952 17.9194 16.5203 17.3958L17.6511 17.7727L17.6533 17.7732C18.0864 17.9175 18.3034 17.9899 18.4476 17.9384C18.5733 17.8936 18.6715 17.7946 18.7163 17.6689C18.7678 17.5245 18.6958 17.3076 18.551 16.8733L18.1741 15.7425L18.3003 15.5333C18.7461 14.754 19 13.8512 19 12.8892C19 9.94356 16.6126 7.55566 13.667 7.55566L13.4673 7.55934L13.3666 7.56426",
    stroke: "#FF9494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatConversationCircle);
export default __webpack_public_path__ + "static/media/Chat_Conversation_Circle.8309184f6c88a76da896fd3c3294e410.svg";
export { ForwardRef as ReactComponent };